function resize({ target }) {
  target.style.height = "1px";
  let rows = target.getAttribute("rows") | 1
  rows = parseInt(rows)
  const lineHeight = getStyle(target, "line-height") | 12;
  if(target.value == ""){
	target.style.height = (+target.scrollHeight * rows)+"px";	
  }else{
	  if(lineHeight * rows > +target.scrollHeight){
		target.style.height = (+target.scrollHeight * rows)+"px";
	  } else { 
		target.style.height = (+target.scrollHeight)+"px";	
	  }
  }
}

function getStyle(el,styleProp)
{
    if (el.currentStyle)
        var y = el.currentStyle[styleProp];
    else if (window.getComputedStyle)
        var y = document.defaultView.getComputedStyle(el,null).getPropertyValue(styleProp);
    return y;
}

export function text_area_resize(el) {
	resize({ target: el });
	el.style.overflow = 'hidden';
	el.addEventListener('input', resize);
	
	return {
		destroy: () => el.removeEventListener('input', resize)
	}
}